import React from 'react';
import ButtonBlue from '../../Buttons/ButtonBlue';
import './home-page-about-me.css';

const HomePageAboutMe = () => {
  return (
    <div className="wrapper-darker">
      <div className="home-section">
        <h2 className="title-blue">About Me</h2>
        <p className="about-me-summary">
          Welcome to my space! I’m passionate about sharing what I've learned through my journey of experimentation and discovery. My goal is to help you find your own unique path by offering insights and lessons from my own experiences. Let’s explore together!
        </p>
        <div className="center">
          <ButtonBlue destination={'/profile'} text={'Learn More'} />
        </div>
      </div>
    </div>
  );
};

export default HomePageAboutMe;